import type { Options } from 'react-markdown'
import { Suspense, lazy, useEffect } from 'react'
const Markdown = lazy(() => import('react-markdown'))

export function LazyMarkdown({
  children,
  remarkPlugins,
  onRendered,
}: {
  children: string
  remarkPlugins?: Options['remarkPlugins']
  onRendered?: () => void
}) {
  return (
    <Suspense fallback={<></>}>
      <>
        <Markdown remarkPlugins={remarkPlugins}>{children}</Markdown>
        <RenderSignal onRendered={onRendered} signalKey={children} />
      </>
    </Suspense>
  )
}

function RenderSignal({
  onRendered,
  signalKey,
}: {
  onRendered?: () => void
  signalKey: string
}) {
  useEffect(() => {
    onRendered?.()
  }, [onRendered, signalKey])

  return null
}
